export default __webpack_public_path__ + "assets/ico_feed_updates-a205aa0b.svg";